// Google Tag Manager dataLayer helper. The GTM container snippet lives in
// public/index.html; here we only push events. Safe no-op if GTM is absent.
export function pushEvent(event, params = {}) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}
